// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"180":"App","214":"views-error"}[chunkId] + "." + {"180":"8a3f6b87","214":"33f37cbc"}[chunkId] + ".chunk.css";
};